export enum StorageKey {
  Rulers = 'Rulers',
  Autoplay = 'Autoplay',
  Volume = 'Volume',
  Mute = 'Mute',
  User = 'User',
  Session = 'Session',
}
